import { FC } from 'react'

import { ProductAttribute } from '../../../utils/types/Product'

import styles from '../../../styles/StandardTest.module.less'

interface StandardTestProps {
  standardTest: ProductAttribute
}

const StandardTest: FC<StandardTestProps> = ({ standardTest }) => (
  <div className={styles['standard-test']}>
    {standardTest['attribute.label']}
  </div>

)

export default StandardTest
